import { displayToast } from '../../../../helpers/notification';
import { AdminSettingTypes as Type } from '../../../types/adminsetting';

export function updateAdminRequest(body: any) {
  return {
    type: Type.UPDATE_ADMIN_REQUEST,
    body: body,
  };
}

export function updateAdminRequestSuccess(data: any) {
  return {
    type: Type.UPDATE_ADMIN_REQUEST_SUCCESS,
    payload: data,
  };
}

export function updateAdminRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.UPDATE_ADMIN_REQUEST_FAILURE,
    error: error,
  };
}

export function resetStateUpdateAdmin() {
  return {
    type: Type.RESET_UPDATE_ADMIN_STATE,
  };
}
